import { render } from "./backendNotifications.vue?vue&type=template&id=ac17c74a&ts=true"
import script from "./backendNotifications.vue?vue&type=script&lang=ts"
export * from "./backendNotifications.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__